<template>
  <div class="mainWrapperOuter">
    <img class="headerBg" src="../../assets/images/my_center_bg2.png" alt />
    <div class="mainWrapperInter">
      <div class="leftPart">
        <div class="topPart">
          <div class="avatarOuter">
            <img src="../../assets/images/avatar.png" alt />
            <!-- <img
              class="editOuter"
              src="../../assets/images/edit.png"
              alt=""
            />-->
          </div>
          <div class="login">上次登录: {{ userInfo.loginTime || '' }}</div>
          <div class="infoOuter">
            <span>信息完整度:</span>
            <el-progress :text-inside="true" :percentage="userInfo.progress" :color="colorList"></el-progress>
          </div>
          <!--          <div class="authOuter">-->
          <!--            <div class="authInner">-->
          <!--              <img src="../assets/images/certified.png" alt="" />-->
          <!--              <span>已认证</span>-->
          <!--            </div>-->
          <!--            <div class="authInner" style="margin-left: 10px">-->
          <!--              <img src="../assets/images/authorized.png" alt="" />-->
          <!--              <span>已授权</span>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="bottomPart">
          <div class="tabOuter tabMainOuter">
            <div class="tabInner">
              <img src="../../assets/images/my_center.png" alt />
              <span>用户中心</span>
            </div>
          </div>

          <!-- <div
            class="tabOuter"
            v-if="getSourceType === '1' || getSourceType === '2'"
          >
            <div class="tabInner">
              <img
                src="../../assets/images/card.png"
                alt
              /> <span>我的卡包</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'card' ? 'activateTab' : ''"
                @click="goTab('card')"
                v-if="getSourceType === '1'"
              >优惠券 </div>
            </div>
          </div>-->

          <div class="tabOuter">
            <div class="tabInner">
              <img src="../../assets/images/base_info.png" alt />
              <span>基本信息</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'PreviewInformation' ? 'activateTab' : ''"
                @click="goTab('PreviewInformation')"
              >信息预览</div>
              <div 
                class="tabItemInter" v-if="getSourceType === '1'"
                :class="currentTab === 'FinanceDetail' ? 'activateTab' : ''"
                @click="goTab('FinanceNeedsDetail')"
              >融资需求明细</div>
              <div 
                class="tabItemInter" v-if="getSourceType === '2' || getSourceType === '6'"
                :class="currentTab === 'FinanceDetail' ? 'activateTab' : ''"
                @click="goTab('FinanceDetail')"
              >融资需求明细</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'easyLoanSearch' ? 'activateTab' : ''"
                @click="goTab('easyLoanSearch')"
                v-if="getSourceType === '3'|| getSourceType === '4' || getSourceType === '6'"
              >易贷码查询</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'authAudit' ? 'activateTab' : ''"
                @click="goTab('authAudit')"
                v-if="getSourceType === '4'"
              >授权书审核</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'whiteList' ? 'activateTab' : ''"
                @click="goTab('whiteList')"
                v-if="getSourceType === '4'"
              >登录白名单管理</div>
            </div>
          </div>
          <div
            class="tabOuter"
            v-if="getSourceType === '1' || getSourceType === '3'||getSourceType === '6'||getSourceType === '5' ||getSourceType === '2'"
          >
            <div class="tabInner">
              <img src="../../assets/images/auth_download.png" alt />
              <span>融资授权</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'newAuth' ? 'activateTab' : ''"
                @click="goTab('newAuth')"
                v-if="getSourceType === '1'"
              >新的申请</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'historyRecord' ? 'activateTab' : ''"
                @click="goTab('historyRecord')"
                v-if="getSourceType === '1'"
              >历史记录</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'DraftsBox' ? 'activateTab' : ''"
                @click="goTab('DraftsBox')"
                v-if="getSourceType === '1'"
              >草稿箱</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'authDownload' ? 'activateTab' : ''"
                @click="goTab('authDownload')"
                v-if="getSourceType === '1'"
              >授权书下载</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'AuthManagement' ? 'activateTab' : ''"
                @click="goTab('AuthManagement')"
                v-if="getSourceType === '6' ||getSourceType === '5'||getSourceType === '2'"
              >授权管理</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'AuthManagementSearch' ? 'activateTab' : ''"
                @click="goTab('AuthManagementSearch')"
                v-if="getSourceType === '5'||getSourceType === '2'"
              >信用数据查询</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'DataReport' ? 'activateTab' : ''"
                @click="goTab('DataReport')"
                v-if="getSourceType === '6' ||getSourceType === '5'||getSourceType === '2'"
              >授权书上报</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'CreditCenter' ? 'activateTab' : ''"
                @click="goTab('CreditCenter')"
                v-if=" getSourceType === '6' "
              >授权书审核</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'BankaythView' ? 'activateTab' : ''"
                @click="goTab('BankaythView')"
                v-if="getSourceType === '5' || getSourceType === '2'"
              >银行上报详情</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'reviewWait' ? 'activateTab' : ''"
                @click="goTab('reviewWait')"
                v-if="getSourceType === '3'"
              >待审核</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'reviewApprove' ? 'activateTab' : ''"
                @click="goTab('reviewApprove')"
                v-if="getSourceType === '3'"
              >审核通过</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'reviewReject' ? 'activateTab' : ''"
                @click="goTab('reviewReject')"
                v-if="getSourceType === '3'"
              >审核不通过</div>
            </div>
          </div>
          <div class="tabOuter" v-if="getSourceType === '1' || getSourceType === '2'">
            <div class="tabInner">
              <img src="../../assets/images/finance_product.png" alt />
              <span>金融产品</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'publishProduct' ? 'activateTab' : ''"
                @click="goTab('publishProduct')"
                v-if="getSourceType === '2'"
              >产品管理</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'financeProduct' ? 'activateTab' : ''"
                @click="goTab('financeProduct')"
              >对接记录</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'applicationRecord' ? 'activateTab' : ''"
                @click="goTab('applicationRecord')"
                v-if="getSourceType === '1'"
              >申请记录</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'customerRecommend' ? 'activateTab' : ''"
                @click="goTab('customerRecommend')"
                v-if="getSourceType === '2'"
              >客户推荐</div>
            </div>
          </div>
          <div class="tabOuter" v-if="getSourceType === '2'">
            <div class="tabInner">
              <img src="../../assets/images/businessReport.png" alt />
              <span>业务上报</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'DataReportDetail' ? 'activateTab' : ''"
                @click="goTab('DataReportDetail')"
              >数据上报</div>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'BusinessReport' ? 'activateTab' : ''"
                @click="goTab('BusinessReport')"
              >历史记录</div>
            </div>
          </div>
          <div class="tabOuter" v-if="getSourceType === '2' && this.status === 1">
            <div class="tabInner">
              <img src="../../assets/images/inventory.png" alt />
              <span>机构管理</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'userInventory' ? 'activateTab' : ''"
                @click="goTab('userInventory')"
              >用户清单</div>
            </div>
          </div>
          
          <div class="tabOuter" v-if="getSourceType === '4' ">
            <div class="tabInner">
              <img src="../../assets/images/history.png" alt />
              <span>客户推荐</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'specialProducts' ? 'activateTab' : ''"
                @click="goTab('specialProducts')"
              >已申请特色产品企业</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'recommendedEnterprise' ? 'activateTab' : ''"
                @click="goTab('recommendedEnterprise')"
              >待推荐企业</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'recommendHistory' ? 'activateTab' : ''"
                @click="goTab('recommendHistory')"
              >推荐历史</div>
            </div>
          </div>
          <div class="tabOuter" v-if="getSourceType === '4'">
            <div class="tabInner">
              <img src="../../assets/images/approve.png" alt />
              <span>产品管理</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'productApproval' ? 'activateTab' : ''"
                @click="goTab('productApproval')"
              >产品审批</div>
            </div>
          </div>
          <div class="tabOuter" v-if="getSourceType === '4'">
            <div class="tabInner">
              <img src="../../assets/images/platform_statistics.png" alt />
              <span>平台统计</span>
            </div>
            <div class="tabItemOuter">
              <div
                class="tabItemInter"
                :class="currentTab === 'resultStatistics' ? 'activateTab' : ''"
                @click="goTab('resultStatistics')"
              >平台总体融资成效</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'ReportResults' ? 'activateTab' : ''"
                @click="goTab('ReportResults')"
              >业务上报历史</div>
              <div
                v-if="getDeptId ==='5'"
                class="tabItemInter"
                :class="currentTab === 'businessSubmission' ? 'activateTab' : ''"
                @click="goTab('businessSubmission')"
              >业务报送监管</div>
              <!-- <div
                class="tabItemInter"
                :class="currentTab === 'UserStatistics' ? 'activateTab' : ''"
                @click="goTab('UserStatistics')"
              >用户统计</div>-->
              <div
                class="tabItemInter"
                :class="currentTab === 'DetailsXydai' ? 'activateTab' : ''"
                @click="goTab('DetailsXydai')"
              >获贷明细</div>

              <div
                class="tabItemInter"
                :class="currentTab === 'OperationLog' ? 'activateTab' : ''"
                @click="goTab('OperationLog')"
              >操作日志</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'Loginlog' ? 'activateTab' : ''"
                @click="goTab('Loginlog')"
              >登录日志</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'EnterinfoSumm' ? 'activateTab' : ''"
                @click="goTab('EnterinfoSumm')"
              >企业填报信息汇总</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'Checkinfinance' ? 'activateTab' : ''"
                @click="goTab('Checkinfinance')"
              >入住金融机构汇总</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'Entermanage' ? 'activateTab' : ''"
                @click="goTab('Entermanage')"
              >企业管理</div>
              <div
                class="tabItemInter"
                :class="currentTab === 'userManagement' ? 'activateTab' : ''"
                @click="goTab('userManagement')"
              >用户管理</div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightPart">
        <finance-detail v-if="currentTab === 'FinanceDetail'" :getSourceType="getSourceType"/>
        <finance-needs-detail v-if="currentTab === 'FinanceNeedsDetail'" :getSourceType="getSourceType"/>
        <Entermanage v-if="currentTab === 'Entermanage'" />
        <OperationLog v-if="currentTab === 'OperationLog'" />
        <DetailsXydai v-if="currentTab === 'DetailsXydai'" />
        <Checkinfinance v-if="currentTab === 'Checkinfinance'" />
        <Loginlog v-if="currentTab === 'Loginlog'" />
        <EnterinfoSumm v-if="currentTab === 'EnterinfoSumm'" />
        <finance-product v-if="currentTab === 'financeProduct'" />
        <auth-download v-if="currentTab === 'authDownload'" />
        <AuthManagement v-if="currentTab === 'AuthManagement'" />
        <AuthManagementSearch v-if="currentTab === 'AuthManagementSearch'" />
        <BankaythView v-if="currentTab === 'BankaythView'" />
        <DataReport v-if="currentTab === 'DataReport'" />
        <credit-auth v-if="currentTab === 'creditAuth'" />
        <new-auth v-if="currentTab === 'newAuth'" @send="goTab" />
        <history-record v-if="currentTab === 'historyRecord'" />
        <drafts-box v-if="currentTab === 'DraftsBox'" @send="goTab" />
        <review-approve v-if="currentTab === 'reviewApprove'" />
        <review-reject v-if="currentTab === 'reviewReject'" />
        <review-wait v-if="currentTab === 'reviewWait'" />
        <user-inventory v-if="currentTab === 'userInventory'" />
        <business-report v-if="currentTab === 'BusinessReport'" />
        <result-statistics v-if="currentTab === 'resultStatistics'" />
        <publish-product v-if="currentTab === 'publishProduct'" />
        <application-record v-if="currentTab === 'applicationRecord'" />
        <customer-recommend v-if="currentTab === 'customerRecommend'" />
        <recommend-history v-if="currentTab === 'recommendHistory'" />
        <recommended-enterprise v-if="currentTab === 'recommendedEnterprise'" />
        <special-products v-if="currentTab === 'specialProducts'" />
        <business-submission v-if="currentTab === 'businessSubmission'" />
        <product-approval v-if="currentTab === 'productApproval'" />
        <preview-information v-if="currentTab === 'PreviewInformation'" />
        <user-statistics v-if="currentTab === 'UserStatistics'" />
        <card v-if="currentTab === 'card'" />
        <CreditCenter v-if="currentTab === 'CreditCenter'" />
        <DataReportDetail v-if="currentTab === 'DataReportDetail'" />
        <report-results v-if="currentTab === 'ReportResults'" />
        <user-management v-if="currentTab === 'userManagement'" />
        <easyloan-search v-if="currentTab === 'easyLoanSearch'" :getSourceType="getSourceType" />
        <white-list v-if="currentTab === 'whiteList'" :getSourceType="getSourceType"/>
          
        <auth-audit v-if="currentTab === 'authAudit'" />
      </div>
    </div>
  </div>
</template>

<script>
import { selectNewDemand } from "@/api/login";
import DataReportDetail from "../../components/auth/DataReportDetail";
import Entermanage from "../../components/loglist/Entermanage";
import OperationLog from "../../components/loglist/OperationLog";
import DetailsXydai from "../../components/loglist/DetailsXydai";
import Checkinfinance from "../../components/loglist/Checkinfinance";
import UserManagement from "../../components/userManagement/index";
import EasyloanSearch from "../../components/userManagement/easyLoanSearch.vue";
import WhiteList from "../../components/userManagement/whiteList.vue";
import AuthAudit from "../../components/userManagement/authAudit.vue";
import EnterinfoSumm from "../../components/loglist/EnterinfoSumm";
import Loginlog from "../../components/loglist/Loginlog";
import BusinessReport from "../../components/businessReport";
import FinanceProduct from "../../components/production/FinanceProduct";
import AuthDownload from "../../components/auth/AuthDownload";
import AuthManagement from "../../components/auth/AuthManagement";
import AuthManagementSearch from "../../components/auth/AuthManagementSearch";
import DataReport from "../../components/auth/DataReport";
import BankaythView from "../../components/auth/BankaythView";
import CreditAuth from "../../components/CreditAuth";
import NewAuth from "../../components/auth/NewAuth";
import HistoryRecord from "../../components/auth/HistoryRecord";
import DraftsBox from "../../components/auth/DraftsBox";
import ReviewApprove from "../../components/review/ReviewApprove";
import ReviewReject from "../../components/review/ReviewReject";
import ReviewWait from "../../components/review/ReviewWait";
import UserInventory from "../../components/user/UserInventory";
import ResultStatistics from "@/components/statistics/ResultStatistics";
import PublishProduct from "@/components/production/PublishProduct";
import ApplicationRecord from "@/components/production/ApplicationRecord";
import CustomerRecommend from "@/components/production/CustomerRecommend";
import RecommendHistory from "@/components/statistics/recommendHistory";
import RecommendedEnterprise from "@/components/statistics/recommendedEnterprise";
import BusinessSubmission from "@/components/statistics/BusinessSubmission";
import ProductApproval from "@/components/statistics/productApproval";
import PreviewInformation from "@/components/previewInformation";
import UserStatistics from "@/components/statistics/userStatistics";
import Card from "@/components/card/card";
import SpecialProducts from "@/components/statistics/specialProducts";
import ReportResults from "@/components/statistics/ReportResults";
import FinanceDetail from "../../components/finance/FinanceDetail";
import FinanceNeedsDetail from "../../components/finance/FinanceNeedsDetail.vue";
import CreditCenter from "../../components/auth/creditCenter.vue";
export default {
  components: {
    CreditCenter,//授权书审核
    FinanceDetail, //信用办+银行
    FinanceNeedsDetail,//企业
    DataReportDetail,
    Entermanage,
    OperationLog,
    UserManagement,
    DetailsXydai,
    Checkinfinance,
    EnterinfoSumm,
    Loginlog,
    AuthManagement,
    AuthManagementSearch,
    DataReport,
    BankaythView,
    WhiteList,
    FinanceProduct,
    AuthDownload,
    CreditAuth,
    NewAuth,
    HistoryRecord,
    DraftsBox,
    ReviewApprove,
    ReviewReject,
    ReviewWait,
    BusinessReport,
    UserInventory,
    ResultStatistics,
    PublishProduct,
    ApplicationRecord,
    CustomerRecommend,
    RecommendHistory,
    RecommendedEnterprise,
    BusinessSubmission,
    ProductApproval,
    PreviewInformation,
    UserStatistics,
    Card,
    SpecialProducts,
    ReportResults,
    EasyloanSearch,
    AuthAudit
  },
  data() {
    return {
      userInfo: {
        avatar: "",
        role: "",
        loginTime: "",
        progress: 100,
        isAuthorized: true,
        isCertified: true
      },
      applicationSum: 0,
      demandSum: 0,
      colorList: "#2981EE",
      currentTab: "",
      status: 0
    };
  },
  computed: {
    getSourceType: function() {
      return this.$store.getters.sourceType;
    },
    getBankAuth: function() {
      return this.$store.state.user.bankAuth;
    },
    getcurrentTab: function() {
      return sessionStorage.getItem("currentTab");
    },
    getuser: function() {
      return sessionStorage.getItem("user");
    },
    getloginTime: function() {
      return sessionStorage.getItem("loginTime");
    },
    getDeptId: function() {
      return sessionStorage.getItem("deptId");
    },
    open() {
      this.$alert('<div><p>您有' + this.demandSum + '条新的融资需求待处理。</p><p>您有' + this.applicationSum + '条产品对接记处理。</p></div>', '提示', {
          dangerouslyUseHTMLString: true
        });
    }
  },
  mounted(){
    selectNewDemand().then(res => {
      if (res.data.code === 200) {
        console.log(res.data.data);
        this.applicationSum = res.data.data.applicationSum;
        this.demandSum = res.data.data.demandSum;
        if( this.applicationSum || this.demandSum ){
          console.log(22222);
          this.open();
        }
      }
    })
  },
  created() {
    let user = JSON.parse(this.getuser);
    if (user) {
      this.userInfo.loginTime = user.sstCustom.loginTime;
    }
    let loginTime = this.getloginTime;
    if (loginTime) {
      this.userInfo.loginTime = loginTime;
    }

    if (this.getSourceType == 2) {
      if (this.getBankAuth !== null) {
        const index = this.getBankAuth.indexOf(1);
        if (index !== -1) {
          this.status = 1;
        }
      }
    }
    const name = sessionStorage.getItem("currentTab");

    if (name) {
      this.currentTab = name;
    } else {
      if (this.getSourceType === "1") {
        this.currentTab = "financeProduct";
      } else if (this.getSourceType === "2") {
        this.currentTab = "financeProduct";
      } else if (this.getSourceType === "3") {
        this.currentTab = "reviewWait";
        this.$store.commit("setIsList", true);
      } else if (this.getSourceType === "4") {
        this.currentTab = "resultStatistics";
      }
      sessionStorage.setItem("currentTab", this.currentTab);
    }
    // let _this = this;
    // this.$notify({
    //   title: '自定义位置',
    //   message: '右上角弹出的消息',
    //   duration: 0,
    //   onClick () {
    //     _this.defineCallBack(); //自定义回调,message为传的参数
    //   }
    // })
  },
  methods: {
    // defineCallBack () {
    // },
    goTab(name) {
      this.currentTab = name;
      if (name.indexOf("review") !== -1) {
        this.$store.commit("setIsList", true);
      } else if (name === "historyRecord") {
        this.$store.commit("setIsList", true);
      } else if (name !== "ReportResults") {
        sessionStorage.removeItem("status");
      }
      sessionStorage.setItem("currentTab", this.currentTab);
    }
  },
  destroyed() {
    sessionStorage.removeItem("currentTab");
    sessionStorage.removeItem("status");
  }
};
</script>

<style lang="less" scoped>
.mainWrapperOuter {
  min-width: 100%;
  color: #2a2a2a;
  box-sizing: border-box;
  // user-select: none;

  .headerBg {
    width: 100%;
    min-height: 240px;
  }

  .mainWrapperInter {
    width: 1280px;
    margin: 20px auto 0;
    display: flex;

    .leftPart {
      min-width: 230px;

      .topPart {
        height: 250px;
        border-radius: 6px;
        background: #fff;
        box-sizing: border-box;
        padding: 30px 15px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .avatarOuter {
          width: 120px;
          height: 120px;
          margin-bottom: 20px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }

          .editOuter {
            position: absolute;
            width: 50px;
            height: 50px;
            left: 80px;
            top: 80px;
            cursor: pointer;
          }
        }

        .login {
          margin-bottom: 15px;
        }

        .infoOuter {
          display: flex;
          align-items: center;
          /deep/.el-progress {
            width: 104px;
            margin-left: 5px;
            .el-progress-bar__outer {
              height: 18px !important;
            }
          }
        }

        .authOuter {
          display: flex;

          .authInner {
            display: flex;
            align-items: center;

            img {
              width: 40px;
              height: 40px;
            }

            span {
              font-weight: 550;
            }
          }
        }
      }

      .bottomPart {
        margin-top: 23px;
        min-height: 560px;
        border-radius: 6px;
        background: #fff;
        padding: 10px;
        box-sizing: border-box;

        .tabOuter {
          padding: 20px 20px 10px 20px;
          border-bottom: 1px solid #f3f4f9;

          .tabInner {
            display: flex;
            align-items: center;

            img {
              width: 14px;
              height: 16px;
              margin-right: 4px;
            }

            span {
              color: #2a2a2a;
              font-size: 18px;
              font-weight: 550;
            }
          }

          .tabItemOuter {
            margin-left: 18px;
            padding-top: 10px;

            .tabItemInter {
              padding: 10px 0;
              color: #2a2a2a;
              font-size: 16px;
              cursor: pointer;
            }

            .activateTab {
              color: #2981ee;
            }
          }
        }

        .tabOuter:last-child {
          border-bottom: unset;
        }

        .tabMainOuter {
          padding-bottom: 20px;
          span {
            font-size: 20px;
            font-weight: 450;
          }
        }
      }
    }

    .rightPart {
      width: 1070px;
      margin-left: 20px;
    }
  }
}

/deep/ .el-progress-bar__inner {
  text-align: center;
}
</style>

